<script lang="ts">
	export let canonical = null;
	export let title = null;
	export let description = null;
	export let additionalMetaTags = null;
	export let twitter = null;
	export let noIndex = null;
</script>

<svelte:head>
	{#if canonical}
		<link rel="canonical" href={canonical} />
	{/if}
	{#if title}
		<title>{title}</title>
	{/if}
	{#if description}
		<meta name="description" content={description} />
	{/if}
	{#if additionalMetaTags}
		{#each additionalMetaTags as tag}
			<meta property={tag.property} content={tag.content} />

      {#if twitter && tag.property === 'og:image'}
				<meta name="twitter:image" content={tag.content} />
			{/if}

		{/each}
	{/if}
	{#if twitter}
		<meta name="twitter:card" content="summary" />
		<meta name="twitter:site" content={`@${twitter.split('twitter.com/')[1]}`} />
		<meta name="twitter:title" content={title} />
		<meta name="twitter:description" content={description} />
		<!-- <meta name="twitter:image" content={tag.content}> -->
	{/if}
	{#if noIndex}
		<meta name="robots" content="noindex" />
	{/if}
</svelte:head>
